<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">交易系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易白名单管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="never" class="page-content">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="卖出白名单" name="ask"></el-tab-pane>
        <el-tab-pane label="买入白名单" name="bid"></el-tab-pane>
      </el-tabs>

      <div class="page-actions">
        <label style="font-size: 14px;">交易对：</label>
        <el-select
          :value="$store.state.tradeWhitelist.currentPair"
          @change="setPair"
          placeholder="请选择">
          <el-option
              v-for="item in pairs"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleAdd">添加</el-button>
      </div>
      <el-table :data="activeTab === 'ask' ? askWhitelist : bidWhitelist" border>
        <el-table-column label="用户ID">
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
<!--              <el-button size="mini" @click="handleEdit(scope.$index)">编辑</el-button>-->
              <el-button
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  size="small"
                  @click="handleEdit(scope.$index)"
              ></el-button>
<!--              <el-button size="mini" type="danger" @click="handleDelete(scope.$index)">删除</el-button>-->
              <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="handleDelete(scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

      <!-- 新增对话框组件 -->
      <whitelist-edit-dialog
        :current-type="activeTab"
        :visible="showEditDialog"
        :item="currentEditItem"
        :whitelist="activeTab === 'ask' ? askWhitelist : bidWhitelist"
        @close="handleDialogClose"
        @submit="handleDialogSubmit"
      />
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import WhitelistEditDialog from './components/update/index.vue';

export default {
  name: 'TradeWhitelist',
  components: { WhitelistEditDialog },
  data() {
    return {
      activeTab: 'ask',
      currentEditItem: null,
      showEditDialog: false,
      queryData: {}
    };
  },
  async mounted() { // 修改：改为async/await语法
    await this.fetchAllPair(); // 先确保交易对数据加载完成
    this.fetchWhitelist(this.activeTab);
  },
  computed: {
    ...mapState('tradeWhitelist', ['askWhitelist', 'bidWhitelist', 'pairs']),
    activeList() {
      return this.activeTab === 'ask'
          ? this.askWhitelist
          : this.bidWhitelist;
    }
  },
  methods: {
    ...mapActions('tradeWhitelist', ['fetchWhitelist', 'updateList', 'fetchAllPair']),

    handleTabChange(tab) {  // 修改：添加tab参数接收事件对象
      // if (!this.validateNamespace()) return;
      this.fetchWhitelist(tab.name);  // 修改：使用tab.name替代this.activeTab，确保获取最新类型
    },

    handleAdd() {
      this.currentEditItem = null;
      this.showEditDialog = true;
    },

    setPair(pair) {  // 修改选择器处理逻辑
      this.$store.commit('tradeWhitelist/setCurrentPair', pair);
      this.fetchWhitelist(this.activeTab);
    },

    handleEdit(index) {
      this.currentEditItem = {
        index,
        value: this.activeList[index]
      };
      this.showEditDialog = true;
    },

    handleDelete(index) {
      const newList = [...this.activeList];
      newList.splice(index, 1);

      this.updateList({
        type: this.activeTab,
        newList
      });
    },

    handleDialogSubmit(newList) {
      this.updateList({
        type: this.activeTab,
        newList
      }).then(() => {
        this.showEditDialog = false;
        this.currentEditItem = null;
      });
    },

    handleDialogClose() {
      this.showEditDialog = false;
      this.currentEditItem = null;
    },
  }
};
</script>
